import { z } from "zod";

// Task list color
export const taskListColorValues = [
    "Gray",
    "Red",
    "Orange",
    "Yellow",
    "Amber",
    "Lime",
    "Green",
    "Teal",
    "Sky",
    "Blue",
    "Purple",
    "Pink",
] as const;
export const taskListColorSchema = z.enum(taskListColorValues);
export type TaskListColor = z.infer<typeof taskListColorSchema>;

// Tasklist type for filtering
export const taskListTypeValues = ["tasklist", "assigned-to-me", "created-by-me", "all", "subtasks"] as const;
export const taskListTypeSchema = z.enum(taskListTypeValues);
export type TaskListType = z.infer<typeof taskListTypeSchema>;

export const completedTasksTypeValues = ["past_day", "past_week", "past_month", "none", "all"] as const;
export const completedTasksTypeSchema = z.enum(completedTasksTypeValues);
export type CompletedTasksType = z.infer<typeof completedTasksTypeSchema>;

export const taskListOutputSchema = z.object({
    id: z.number(),
    name: z.string(),
    color: taskListColorSchema,
    isArchived: z.boolean(),
    createdById: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
    guestsVisible: z.boolean(),
});

export const listInfoOutputSchema = z.object({
    id: z.number(),
    name: z.string(),
    allowed: z.boolean(),
});
export type ListInfoOutput = z.infer<typeof listInfoOutputSchema>;
export type TaskListOutput = z.infer<typeof taskListOutputSchema>;

export const taskListListOutputSchema = z.object({
    id: z.number(),
    name: z.string(),
    color: taskListColorSchema,
});
export type TaskListListOutput = z.infer<typeof taskListListOutputSchema>;
